import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { OnlineOrder, Customer, Company } from '../../../shared/models';

import { OnlineOrdersService } from '../../../shared/services/online-orders.service';
import { CustomerService } from '../../../shared/services/customer.service';
import { faUtensils, faClock, faMapMarker, faCommentDots } from '../../../icons';

@Component({
    selector: 'app-my-orders',
    templateUrl: './my-orders.component.html',
    styleUrls: ['./my-orders.component.scss'],
    standalone: false
})
export class MyOrdersComponent implements OnInit {
	onlineOrders: OnlineOrder[];
	customer: Customer;
  whatsMsg: string;
  loading: boolean;

  pollingInterval: any;

  faUtensils = faUtensils;
  faClock = faClock;
  faMapMarker = faMapMarker;
  faCommentDots = faCommentDots;

  constructor(private ooServ: OnlineOrdersService,
  	private customerServ: CustomerService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
  	this.customer = this.customerServ.getCustomer();

    if(this.customer) {
      this.whatsMsg = `Olá meu nome é ${this.customer.name}, sobre o meu pedido feito pelo site:`;

      this.loading = true;

      this._loadOrders();
      this.pollingInterval = setInterval(() => {
        this._loadOrders();
      }, 10000);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.pollingInterval);
  }

  onlineOrderDetails(oo: OnlineOrder) {
    this.ooServ.setSelected(oo);
    this.router.navigate([String(oo.id)], {relativeTo: this.route});
  }

  goBack() {
    this.router.navigate(['..'], {relativeTo: this.route});
  }

  goToLogin(event) {
    event.preventDefault();
    this.router.navigate(['../entrar'], {relativeTo: this.route});
  }

  giveFeedback(oo: OnlineOrder) {
    event.stopPropagation();

    const code = oo.eval_code || `@c${oo.customer.id}@oo${oo.id}`;
    location.href = `https://ncommerce.app/avaliacoes/${oo.company.name}/delivery?code=${code}`;
  }

  private _loadOrders() {
    this.ooServ.fetch().subscribe(
      res => {
        let oos = res.online_orders || [];
        if(oos.length > 5) { // get the last 5 orders
          oos = oos.slice(0,5);
        }
        this.onlineOrders = oos;
      },
      err => {},
      () => {
        this.loading = false;
      }
    );
  }
}
